<template>
  <div class="card-container pa-2">
    <v-card class="card" v-for="item in itemList" :key="item.name">
      <v-card-text
        ref="check_cont"
        class="text--primary pa-0 ticket custom-scroll"
      >
        <v-list dense class="py-0">
          <div
            class="cursor-pointer"
            @click="$emit('selectedItemInSummary', item.id)"
          >
            <div
              class="kot-number subheading font-weight-bold table-header pa-2"
            >
              {{ item.name }}

              <v-spacer></v-spacer>
              <div v-if="!isMultipleServiceType(item)">
                <template v-for="service in item.services">
                  <span
                    v-if="service.quantity > 0"
                    :key="service.name"
                    class="pr-2"
                  >
                    <v-icon size="18" :color="'primary'">{{
                      service.icon
                    }}</v-icon
                    ><span
                      v-if="service.name == 'delivery'"
                      class="font-weight-black white--text primary px-1 ml-1"
                      >HD</span
                    >
                  </span>
                </template>
              </div>
              {{ item.qty }}
            </div>
            <div
              v-if="isMultipleServiceType(item)"
              class="kot-number subheading table-header font-weight-bold"
            >
              <template v-for="service in item.services">
                <span
                  v-if="service.quantity > 0"
                  :key="service.name"
                  class="pr-2"
                >
                  <v-icon size="18" :color="'primary'">{{
                    service.icon
                  }}</v-icon
                  ><span
                    v-if="service.name == 'delivery'"
                    class="font-weight-black white--text primary px-1 ml-1"
                    >HD</span
                  >&nbsp;({{ service.quantity }})
                </span>
              </template>
            </div>
          </div>
          <template v-if="item.split.length">
            <div
              v-for="(split, idx) in [
                remainingItem(item, item.split),
                ...item.split,
              ]"
              :key="idx"
            >
              <v-list-tile
                v-if="split.quantity"
                class="py-0"
                :class="{
                  'blue-grey white--text': item.fab,
                }"
              >
                <v-list-tile-action
                  class="subheading font-weight-bold item-qty--action"
                >
                  {{ split.quantity }}
                </v-list-tile-action>

                <v-list-tile-content
                  class="subheading pink--text font-weight-bold"
                  style="white-space: normal"
                >
                  {{ split.modifiers && split.modifiers.join(", ") }}

                  <div
                    class="orange--text font-weight-bold"
                    v-if="split.instructions && split.instructions.length"
                    :key="`instruction-${idx}`"
                  >
                    -> {{ split.instructions.join(", ") }}
                  </div>
                  <div v-if="split.text" class="addon-text">
                    — {{ split.text }} —
                  </div>

                  <div class="subheading font-weight-bold">
                    <template v-for="service in split.services">
                      <span
                        v-if="service.quantity > 0"
                        :key="service.name"
                        class="pr-2"
                      >
                        <v-icon size="18" :color="'primary'">{{
                          service.icon
                        }}</v-icon
                        ><span
                          v-if="service.name == 'delivery'"
                          class="font-weight-black white--text primary px-1 ml-1"
                          >HD</span
                        >&nbsp;({{ service.quantity }})
                      </span>
                    </template>
                  </div>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import { data } from "./data.js";
const serviceTypes = {
  1: { name: "qsr", icon: "flaticon-qsr" },
  2: { name: "takeAway", icon: "flaticon-take-away" },
  3: { name: "table", icon: "flaticon-dining-table" },
  4: { name: "delivery", icon: "flaticon-delivery-scooter-1" },
  5: { name: "bar", icon: "flaticon-bar-service" },
  6: { name: "party", icon: "flaticon-juice" }
};

// Create a name-to-icon map for easy lookup
const serviceTypeIcons = Object.values(serviceTypes).reduce((acc, s) => {
  acc[s.name] = s.icon;
  return acc;
}, {});

export default {
  props: {
    items: {
      type: Array
    }
  },
  methods: {},
  // watch: {
  //   items(v) {
  //     console.log(v, "from watch2222222222");
  //   }
  // },
  computed: {
    itemList() {
      return this.items;
    }
  },
  methods: {
    isMultipleServiceType(item) {
      if (!item.services || !Array.isArray(item.services)) return false;

      const activeServices = item.services.filter((s) => s.quantity > 0);
      return activeServices.length > 1;
    },

    calculateRemainingServiceTypes(splitServices, itemServices) {
      const result = {};
      const serviceNames = [
        "qsr",
        "bar",
        "table",
        "takeAway",
        "delivery",
        "party"
      ];

      serviceNames.forEach((name) => {
        var itemService = itemServices.find((s) => s.name === name);
        var splitService = splitServices.find((s) => s.name === name);

        var itemQty = itemService ? itemService.quantity : 0;
        var splitQty = splitService ? splitService.quantity : 0;
        result[name] = itemQty - splitQty;
      });

      return result;
    },
    remainingItem(item, split) {
      let splitQty = 0;
      const serviceNames = [
        "qsr",
        "bar",
        "table",
        "takeAway",
        "delivery",
        "party"
      ];
      const splitServicesMap = {};

      serviceNames.forEach((name) => (splitServicesMap[name] = 0));

      split.forEach((splitItem) => {
        splitQty += splitItem.quantity;
        (splitItem.services || []).forEach((s) => {
          if (splitServicesMap.hasOwnProperty(s.name)) {
            splitServicesMap[s.name] += s.quantity;
          }
        });
      });

      const splitServices = serviceNames.map((name) => ({
        name,
        quantity: splitServicesMap[name],
        icon: serviceTypeIcons[name] || ""
      }));

      const isEqual = item.qty === splitQty;

      return {
        quantity: isEqual ? null : item.qty - splitQty,
        text: isEqual ? null : "No Addon",
        ...this.calculateRemainingServiceTypes(
          splitServices,
          item.services || []
        ),
        services: serviceNames
          .map((name) => {
            const itemService = (item.services || []).find(
              (s) => s.name === name
            );
            const splitService = splitServices.find((s) => s.name === name);
            const itemQty = itemService ? itemService.quantity : 0;
            const splitQty = splitService ? splitService.quantity : 0;
            const remaining = itemQty - splitQty;

            return {
              name,
              quantity: remaining,
              icon: serviceTypeIcons[name] || ""
            };
          })
          .filter((s) => s.quantity > 0)
      };
    }
  }
};
</script>

<style>
.card-container {
  column-width: 23vw;
  column-gap: 1rem;
  height: calc(100vh - 100px); /* topbar - 48px + 40px , padding - 12px*/
  padding: 1rem;
}

.card {
  display: flex;
  width: 23vw;
  margin-bottom: 1rem;
  break-inside: auto;
}
.card .v-list__tile {
  padding-right: 0px;
}
.addon-text {
  color: #a19f9b;
}
</style>
